import React from 'react';

import CompletenessBanner from './CompletenessBanner';
import useFrqReleasedGrade from './hooks/useFrqReleasedGrade';
import ReleasedGradeView from './ReleasedGradeView.react';

type Props = {
  /** The question this submission answers, used to find the student's own guess. */
  questionId?: string;
  /** The question's rubric, as `question.getMeta().getQuestionRubric()` returns it. */
  rubric?: unknown;
};

/**
 * What a student sees above their submitted free response: the released grade once their teacher
 * has released it, otherwise the completeness banner saying where the submission stands.
 *
 * Owns the guess read so it stays inside the submitted branch — `FreeResponseQuestion` also mounts
 * in Dennis previews and other places with no Apollo client above it.
 *
 * Renders nothing while a grade could still arrive, so the banner is never shown over one.
 */
export default function SubmittedFrqStatus({questionId, rubric}: Props) {
  const {evaluation, isLoading} = useFrqReleasedGrade(questionId);

  if (isLoading) {
    return null;
  }

  return evaluation ? (
    <ReleasedGradeView rubric={rubric} evaluation={evaluation} />
  ) : (
    <CompletenessBanner questionId={questionId} />
  );
}
